import React, { useCallback, useState } from "react";
import { Image, PlayerListElement } from "../../../../../client/api";
import RoundedRectangle from "../../../RoundedRectangle";
import PlayerCard from "./PlayerCard";

type TopScorerPanelProps = {
  player1?: PlayerListElement | null;
  player2?: PlayerListElement | null;
  emblem1?: Image;
  emblem2?: Image;
  goals1?: number;
  goals2?: number;
};

const TopScorerPanel: React.FC<TopScorerPanelProps> = ({
  player1,
  player2,
  emblem1,
  emblem2,
  goals1,
  goals2,
}) => {
  const [clicked, setClicked] = useState<"left" | "right" | null>(null);

  const onLeftClick = useCallback(() => setClicked("left"), []);
  const onRightClick = useCallback(() => setClicked("right"), []);
  const onCloseBanner = useCallback(() => setClicked(null), []);

  return (
    <RoundedRectangle
      className="w-full overflow-hidden bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark"
      hasBorder
      hasTitle
      titleType="upLeft"
      titleKey="topScorerTitle"
    >
      <div className="px-4 pt-4 pb-5 flex-1">
        <div className="flex flex-row flex-wrap items-stretch justify-between h-full gap-3">
          <PlayerCard
            player={player1}
            emblem={emblem1}
            goals={goals1}
            position="left"
            isClicked={clicked === "left"}
            onClick={onLeftClick}
            onCloseBanner={onCloseBanner}
          />
          <PlayerCard
            player={player2}
            emblem={emblem2}
            goals={goals2}
            position="right"
            isClicked={clicked === "right"}
            onClick={onRightClick}
            onCloseBanner={onCloseBanner}
          />
        </div>
      </div>
    </RoundedRectangle>
  );
};

export default TopScorerPanel;
